export default {
	EDITOR: 'EDITOR',
	ADMIN: 'ADMIN',
	OWNER: 'OWNER',
};
